var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import styled from 'styled-components';
const StyledDiv = styled.div `
  padding: 8px 0;
  box-sizing: border-box;
  &:first-child {
    padding-top: 0;
  }
  &:last-child {
    padding-bottom: 0;
  }
  .checkbox {
    box-sizing: border-box;
    padding: 2px 9px;
  }
`;
export const ConfigFieldControl = (_a) => {
    var { className, children } = _a, props = __rest(_a, ["className", "children"]);
    return (React.createElement(StyledDiv, { className: `config-field-control${className ? ` ${className}` : ''}` }, children));
};
export default ConfigFieldControl;
//# sourceMappingURL=ConfigFieldControl.js.map